/* Nolu: små tilføjelser til produktsiden.
   1. Vælger man en størrelse, glider galleriet til størrelsesguiden for den størrelse
      (billedet med alt-teksten "... størrelse S ..."). Farvevalg følger stadig variantens billede.
   2. Knappen til anmeldelserne øverst får stjerner efter det rigtige gennemsnit og ruller ned. */
(function () {
  if (window.__hsPdp) return;
  window.__hsPdp = true;

  var SIZE = /størrelse|size/i;
  var lastSize = null;

  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function slideToSize(value) {
    var galleries = document.querySelectorAll('media-gallery');
    var re = new RegExp('størrelse\\s*:?\\s*' + esc(value) + '(?![\\wæøå])', 'i');
    galleries.forEach(function (gallery) {
      var slides = gallery.querySelectorAll('[data-media-id]');
      for (var i = 0; i < slides.length; i++) {
        var img = slides[i].querySelector('img');
        if (img && re.test(img.getAttribute('alt') || '')) {
          if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(slides[i].dataset.mediaId, false);
          return;
        }
      }
    });
  }

  /* Husk hvilken valgmulighed kunden lige har ændret */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('variant-selects, variant-radios')) return;
    var name = t.name || '';
    var legend = t.closest('fieldset') && t.closest('fieldset').querySelector('legend');
    var label = name + ' ' + (legend ? legend.textContent : '');
    lastSize = SIZE.test(label) ? t.value : null;
    if (lastSize) {
      var v = lastSize;
      /* Temaet skifter selv til variantens billede først; derefter glider vi til guiden */
      setTimeout(function () { slideToSize(v); }, 350);
      setTimeout(function () { if (lastSize === v) slideToSize(v); }, 900);
    }
  }, true);

  function initReviewLink() {
    var link = document.querySelector('[data-hs-rev-link]');
    var sec = document.getElementById('upform-reviews');
    if (!link || !sec) return;
    var total = parseInt(sec.getAttribute('data-review-total'), 10) || 0;
    var avg = parseFloat(sec.getAttribute('data-review-avg')) || 0;
    if (!total || !avg) return;
    var fill = link.querySelector('.hs-rev-link__fill');
    if (fill) fill.style.width = Math.max(0, Math.min(100, avg * 20)) + '%';
    link.setAttribute('aria-label', 'Læs anmeldelserne, gennemsnit ' + String(avg).replace('.', ',') + ' ud af 5 stjerner');
    link.hidden = false;
    link.addEventListener('click', function (e) {
      e.preventDefault();
      sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* 3. Bundle (mængderabat): farvecirkler og størrelsesknapper i stedet for dropdowns.
        Dropdownen bliver liggende skjult, så temaets egen kurv-logik virker uændret. */
  var COLOR = /farve|color|colour|mønster|monster|pattern/i;
  function parseSwatches(qb) {
    var map = {};
    (qb.getAttribute('data-hs-swatches') || '').split(';').forEach(function (p) {
      var i = p.indexOf('='); if (i < 0) return;
      var k = p.slice(0, i).trim(), v = p.slice(i + 1).trim(); if (k && v) map[k.toLowerCase()] = v;
    });
    return map;
  }
  function jsonFrom(qb, sel) { var el = qb.querySelector(sel); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  function imgFor(qb, optIndex, value) {
    var variants = qb.__hsVariants || (qb.__hsVariants = jsonFrom(qb, 'script[type="application/json"][data-has-variants]') || []);
    var cut = qb.__hsCut || (qb.__hsCut = jsonFrom(qb, 'script[data-upform-cutouts]') || {});
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options && v.options[optIndex] === value) {
        var src = cut[v.id] || (v.featured_image && v.featured_image.src);
        if (src) return (src.indexOf('//') === 0 ? 'https:' + src : src) + (src.indexOf('?') > -1 ? '&' : '?') + 'width=80';
      }
    }
    return '';
  }
  function refreshQb(qb) {
    qb.querySelectorAll('.hs-qb-opt').forEach(function (wrap) {
      var sel = wrap.__hsSelect; if (!sel) return;
      wrap.querySelectorAll('button').forEach(function (b, i) {
        var o = sel.options[i];
        b.setAttribute('aria-pressed', o && o.value === sel.value ? 'true' : 'false');
        b.disabled = !!(o && o.disabled);
      });
    });
  }
  function enhanceQb(qb) {
    var sw = parseSwatches(qb);
    qb.querySelectorAll('select.quantity-break__variant-select').forEach(function (sel) {
      if (sel.__hsDone) return;
      sel.__hsDone = true;
      var name = (sel.name || '').replace(/^options\[|\]$/g, '');
      var item = sel.closest('.quantity-break__selector-item');
      var selects = item ? Array.prototype.slice.call(item.querySelectorAll('select')) : [sel];
      var optIndex = selects.indexOf(sel);
      var isColor = COLOR.test(name);
      /* Højst 4 farver: cirkler i stedet for dropdown i rækkerne under kortene. Flere farver står som tekst */
      var few = isColor && sel.options.length <= 4;
      var wrap = document.createElement('div');
      wrap.className = 'hs-qb-opt' + (isColor ? ' hs-qb-opt--color' : '') + (few ? ' hs-qb-opt--few' : '');
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', name);
      wrap.__hsSelect = sel;
      Array.prototype.forEach.call(sel.options, function (o) {
        var b = document.createElement('button');
        b.type = 'button';
        b.title = o.value;
        if (isColor) {
          b.className = 'hs-qb-sw';
          var dot = document.createElement('span');
          var hex = sw[o.value.toLowerCase()];
          if (hex) dot.style.background = hex;
          else { var src = imgFor(qb, optIndex, o.value); if (src) dot.style.backgroundImage = 'url("' + src + '")'; }
          b.appendChild(dot);
          var vh = document.createElement('span'); vh.className = 'visually-hidden'; vh.textContent = o.value; b.appendChild(vh);
        } else {
          b.className = 'hs-qb-pill';
          b.textContent = o.value;
        }
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          /* Vælg også selve bundlen, hvis den ikke allerede er valgt */
          var label = sel.closest('.quantity-break');
          var radio = label && (label.querySelector('input[type="radio"]') || document.getElementById(label.getAttribute('for') || '') || (label.previousElementSibling && label.previousElementSibling.matches('input[type="radio"]') ? label.previousElementSibling : null));
          if (radio && !radio.checked) radio.click();
          if (sel.value !== o.value) {
            sel.value = o.value;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
          setTimeout(function () { refreshQb(qb); }, 50);
        });
        wrap.appendChild(b);
      });
      var holder = sel.closest('.select') || sel;
      holder.classList.add('hs-qb-hidden');
      if (few) holder.classList.add('hs-qb-swsel');
      holder.parentNode.insertBefore(wrap, holder.nextSibling);
    });
    refreshQb(qb);
  }
  function enhanceAll() { document.querySelectorAll('quantity-breaks').forEach(enhanceQb); }
  document.addEventListener('change', function () {
    setTimeout(enhanceAll, 200);
    setTimeout(enhanceAll, 900);
  });

  /* Hovedproduktets valgte variant (ikke formularer i pakker eller "Køb sammen") */
  function mainIdInput() {
    var vs = document.querySelector('variant-selects[data-section], variant-radios[data-section]');
    var form = vs && document.getElementById('product-form-' + vs.getAttribute('data-section'));
    return (form && form.querySelector('input[name="id"]')) || document.querySelector('product-info input[name="id"]');
  }

  /* 4. Lagerstatus: vis 'Kun X på lager' for den valgte variant, hvis den er lav (1-6) */
  function updateStock() {
    /* "På lager"-linjen skjules for udsolgte varianter */
    var st = document.querySelector('[data-hs-ude]');
    var cur = mainIdInput();
    if (st && cur) st.hidden = (',' + st.getAttribute('data-hs-ude')).indexOf(',' + cur.value + ',') > -1;
    var el = document.querySelector('[data-hs-lager]');
    if (!el) return;
    var idInput = mainIdInput();
    var id = idInput && idInput.value;
    var map = {};
    el.getAttribute('data-hs-lager').split(',').forEach(function (p) { var a = p.split(':'); if (a[0]) map[a[0]] = a[1]; });
    var n = id && map[id];
    el.hidden = !n;
    if (n) el.querySelector('[data-hs-lager-n]').textContent = n;
  }
  document.addEventListener('change', function () { setTimeout(updateStock, 300); });

  /* 5. Mængderabat: før-prisen er altid antal × de valgte varianters aktuelle pris (fra
        Shopify), og prisen er den minus det faste beløb fra de automatiske rabatter. */
  function kr(cents) {
    var v = cents / 100;
    return (v % 1 === 0 ? v.toLocaleString('da-DK') : v.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + ' kr';
  }
  function qbPrices() {
    document.querySelectorAll('quantity-breaks').forEach(function (qb) {
      var variants = qb.__hsVariants || (qb.__hsVariants = jsonFrom(qb, 'script[type="application/json"][data-has-variants]') || []);
      var byId = {}; variants.forEach(function (v) { byId[v.id] = v; });
      var idInput = mainIdInput();
      var main = idInput && byId[idInput.value];
      qb.querySelectorAll('.quantity-break[data-hs-save]').forEach(function (label) {
        var save = parseInt(label.getAttribute('data-hs-save'), 10) || 0;
        var qty = parseInt(label.getAttribute('data-quantity'), 10) || 1;
        if (!save || qty < 2) return;
        var prices = [];
        var hits = [];
        label.querySelectorAll('.quantity-break__selector-item').forEach(function (item) {
          var vals = Array.prototype.map.call(item.querySelectorAll('select'), function (s) { return s.value; });
          var hit = variants.filter(function (v) { return v.options && v.options.every(function (o, n) { return o === vals[n]; }); })[0];
          if (hit) { prices.push(hit.price); hits.push(hit); }
        });
        if (prices.length !== qty) { prices = []; hits = []; for (var i = 0; i < qty; i++) { prices.push(main ? main.price : 0); if (main) hits.push(main); } }
        if (!prices[0]) return;
        /* Køb 2, få den 3. gratis: den billigste af de valgte er gratis */
        if (label.hasAttribute('data-hs-free3')) save = Math.min.apply(null, prices);
        /* 2 stk.-tilbud (snippets/hs-par.liquid): rabat pr. stk. som de automatiske rabatter i Shopify.
           Har produktet en ekstra regel for fx størrelse M, gælder den ved mindst 2 af dem, og den største rabat vinder. */
        var per = parseInt(label.getAttribute('data-hs-per'), 10) || 0;
        if (per) {
          var alt = parseInt(label.getAttribute('data-hs-per-alt'), 10) || 0;
          var av = label.getAttribute('data-hs-alt-value') || '';
          var nAlt = av ? hits.filter(function (v) { return v.options && v.options.indexOf(av) > -1; }).length : 0;
          save = Math.max(per * qty, alt && nAlt >= 2 ? alt * nAlt : 0);
        }
        var sum = prices.reduce(function (a, b) { return a + b; }, 0);
        var same = prices.every(function (p) { return p === prices[0]; });
        var priceEl = label.querySelector('.quantity-break__price');
        var cmpEl = label.querySelector('.quantity-break__compare-price');
        var capEl = label.querySelector('.quantity-break__caption');
        if (priceEl) priceEl.textContent = kr(sum - save);
        if (cmpEl) cmpEl.textContent = same ? qty + ' × ' + kr(prices[0]) : kr(sum);
        if (capEl) capEl.textContent = 'Spar ' + kr(save);
      });
    });
  }
  document.addEventListener('change', function () { setTimeout(qbPrices, 250); setTimeout(qbPrices, 950); });

  /* 6. Kompakt bundle: vælgerne pr. stk. er foldet sammen. Hovedvælgeren øverst styrer 1. stk.
        (temaet synkroniserer selv), og en linje viser, hvad man får. "Vælg forskellige farver"
        folder vælgerne ud. Ved 1 stk. vises ingen ekstra vælger, for den er den samme som øverst. */
  function radioFor(label) {
    return label && (label.querySelector('input[type="radio"]') || document.getElementById(label.getAttribute('for') || '') || (label.previousElementSibling && label.previousElementSibling.matches('input[type="radio"]') ? label.previousElementSibling : null));
  }
  function itemValues(label) {
    return Array.prototype.map.call(label.querySelectorAll('.quantity-break__selector-item'), function (it) {
      return Array.prototype.map.call(it.querySelectorAll('select'), function (s) { return s.value; }).join(' / ');
    });
  }
  function updateSummaries() {
    document.querySelectorAll('.hs-qb-sum').forEach(function (bar) {
      var label = bar.closest('.quantity-break');
      var txt = bar.querySelector('.hs-qb-sum__txt');
      if (label && txt) txt.textContent = itemValues(label).join(' + ');
    });
  }
  function closeAll(qb) {
    qb.querySelectorAll('.quantity-break.hs-qb-open').forEach(function (l) {
      l.classList.remove('hs-qb-open');
      var b = l.querySelector('.hs-qb-pick');
      if (b) { b.setAttribute('aria-expanded', 'false'); b.querySelector('span').textContent = b.__hsTxt || b.querySelector('span').textContent; }
    });
  }
  function compactQb(qb) {
    if (qb.__hsCompact) return;
    qb.__hsCompact = true;
    qb.classList.add('hs-qb-compact');
    /* Vælges et andet kort, lukkes det åbne (temaet skjuler vælgerne i kort, der ikke er valgt) */
    qb.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[type="radio"]')) {
        qb.querySelectorAll('.quantity-break.hs-qb-open').forEach(function (l) { var r = radioFor(l); if (r && !r.checked) { closeAll(qb); } });
      }
    });
    var labels = qb.querySelectorAll('.quantity-break');
    var box = qb.querySelector('.quantity-breaks-container');
    if (box) box.style.setProperty('--hs-qb-cols', String(labels.length || 1));
    /* Kun to kort (3 for 2-produkter): større indhold, så kortene ikke står tomme */
    qb.classList.toggle('hs-qb-two', labels.length === 2);
    qb.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[type="radio"]')) { setTimeout(function () { layoutRows(qb); }, 30); setTimeout(function () { layoutRows(qb); }, 400); }
    });
    window.addEventListener('resize', function () { layoutRows(qb); });
    layoutRows(qb);
  }
  /* 6b. Ved 2 eller 3 stk. vises én række pr. stk. direkte under kortene, så kunden vælger farve
         (og evt. størrelse) til hvert stk. Rækkerne bliver i deres kort (temaets bundle-kode læser dem
         dér), men placeres under kortene. 1. stk. starter med valget øverst. */
  function syncFirst(qb) {
    var variants = qb.__hsVariants || (qb.__hsVariants = jsonFrom(qb, 'script[type="application/json"][data-has-variants]') || []);
    var idInput = mainIdInput();
    var main = idInput && variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0];
    if (!main || !main.options) return;
    qb.querySelectorAll('.quantity-break').forEach(function (l) {
      var first = l.querySelector('.quantity-break__selector-item');
      if (!first) return;
      first.querySelectorAll('select').forEach(function (sel, n) {
        if (main.options[n] != null && sel.value !== main.options[n]) { sel.value = main.options[n]; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
  }
  function layoutRows(qb) {
    var box = qb.querySelector('.quantity-breaks-container');
    if (!box) return;
    var on = null;
    qb.querySelectorAll('.quantity-break').forEach(function (l) {
      var r = radioFor(l);
      var q = parseInt(l.getAttribute('data-quantity'), 10) || 1;
      var act = !!(r && r.checked && q > 1 && l.querySelector('.quantity-break__selector-item'));
      l.classList.toggle('hs-qb-open', act);
      l.classList.toggle('hs-qb-below', act);
      if (act) on = l;
    });
    /* Synlige rækker i almindeligt sidelayout under kortene. De rigtige vælgere bliver skjult i
       kortet (temaets bundle-kode læser dem dér), og rækkerne sender hvert valg videre til dem. */
    var holder = qb.querySelector('.hs-qb-rows');
    if (!holder) {
      holder = document.createElement('div');
      holder.className = 'hs-qb-rows';
      box.parentNode.insertBefore(holder, box.nextSibling);
    }
    if (!on) { qb.__hsOn = null; holder.hidden = true; holder.innerHTML = ''; return; }
    if (qb.__hsOn !== on) { qb.__hsOn = on; syncFirst(qb); }
    renderRows(qb, on, holder);
  }
  function renderRows(qb, on, holder) {
    var items = Array.prototype.slice.call(on.querySelectorAll('.quantity-break__selector-item'));
    var first = items[0];
    var names = Array.prototype.map.call(first.querySelectorAll('select'), function (x) { return (x.name || '').replace(/^options\[|\]$/g, '').toLowerCase(); }).filter(Boolean);
    var sw = parseSwatches(qb);
    holder.hidden = false;
    holder.innerHTML = '';
    var head = document.createElement('p');
    head.className = 'hs-qb-rows__head';
    head.textContent = 'Vælg ' + (names.join(' og ') || 'variant') + ' til hvert stk.';
    holder.appendChild(head);
    items.forEach(function (it, n) {
      var row = document.createElement('div');
      row.className = 'hs-qb-rows__row';
      var num = document.createElement('span');
      num.className = 'hs-qb-rows__num';
      num.textContent = String(n + 1);
      row.appendChild(num);
      Array.prototype.forEach.call(it.querySelectorAll('select'), function (orig, optIndex) {
        var name = (orig.name || '').replace(/^options\[|\]$/g, '');
        var send = function (v) {
          if (orig.value === v) return;
          orig.value = v;
          orig.dispatchEvent(new Event('change', { bubbles: true }));
        };
        if (COLOR.test(name) && orig.options.length <= 4) {
          /* Højst 4 farver: cirkler. Flere farver står som tekst */
          var wrap = document.createElement('div');
          wrap.className = 'hs-qb-rows__sw';
          wrap.setAttribute('role', 'group');
          wrap.setAttribute('aria-label', name + ' til stk. ' + (n + 1));
          Array.prototype.forEach.call(orig.options, function (o) {
            var b = document.createElement('button');
            b.type = 'button';
            b.title = o.value;
            b.disabled = o.disabled;
            b.setAttribute('aria-pressed', o.value === orig.value ? 'true' : 'false');
            var dot = document.createElement('span');
            var hex = sw[o.value.toLowerCase()];
            if (hex) dot.style.background = hex;
            else { var src = imgFor(qb, optIndex, o.value); if (src) dot.style.backgroundImage = 'url("' + src + '")'; }
            b.appendChild(dot);
            var vh = document.createElement('span'); vh.className = 'visually-hidden'; vh.textContent = o.value; b.appendChild(vh);
            b.addEventListener('click', function (e) {
              e.preventDefault();
              send(o.value);
              wrap.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            });
            wrap.appendChild(b);
          });
          row.appendChild(wrap);
        } else {
          var s = document.createElement('select');
          s.className = 'hs-qb-rows__select';
          s.setAttribute('aria-label', name + ' til stk. ' + (n + 1));
          Array.prototype.forEach.call(orig.options, function (o) {
            var op = document.createElement('option');
            op.value = o.value; op.textContent = o.textContent; op.disabled = o.disabled;
            s.appendChild(op);
          });
          s.value = orig.value;
          s.addEventListener('change', function () { send(s.value); });
          row.appendChild(s);
        }
      });
      holder.appendChild(row);
    });
  }
  /* Valg i 1 stk.-kortet flyttes op i hovedvælgeren, så billede, pris og vælger passer sammen */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || sel.tagName !== 'SELECT' || !sel.closest('.quantity-break[data-quantity="1"] .quantity-break__selector-item')) return;
    var name = (sel.name || '').replace(/^options\[|\]$/g, '');
    var vs = document.querySelector('variant-selects[data-section]');
    if (!vs) return;
    var inp = Array.prototype.find.call(vs.querySelectorAll('input[type="radio"]'), function (i) { return i.name === name && i.value === sel.value; });
    if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    else if (!inp) {
      var ms = Array.prototype.find.call(vs.querySelectorAll('select'), function (m) { return (m.name || '').indexOf(name) > -1; });
      if (ms && ms.value !== sel.value) { ms.value = sel.value; ms.dispatchEvent(new Event('change', { bubbles: true })); }
    }
  });
  document.addEventListener('change', function (e) {
    if (!e.target.closest || !e.target.closest('.product__info-container variant-selects, .product__info-container variant-radios')) return;
    setTimeout(function () { document.querySelectorAll('quantity-breaks').forEach(syncFirst); }, 350);
    setTimeout(sizeLine, 50);
  });
  /* 6c. Størrelseslinjen (snippets/hs-stoerrelse-kort.liquid) viser kun den valgte størrelse, så den fylder én linje */
  function sizeLine() {
    var ul = document.querySelector('.product__info-container .hs-size-kort');
    if (!ul) return;
    var cur = Array.prototype.map.call(document.querySelectorAll('.product__info-container variant-selects input[type="radio"]:checked'), function (i) { return i.value; });
    var lis = ul.querySelectorAll('li');
    var hit = false;
    lis.forEach(function (li) { var k = ((li.querySelector('strong') || {}).textContent || '').replace(':', '').trim(); li.__hsK = k; if (cur.indexOf(k) > -1) hit = true; });
    lis.forEach(function (li) { li.hidden = hit && cur.indexOf(li.__hsK) < 0; });
  }
  /* 6d. Størrelsesguide-knappen står ved "Størrelse" lige over størrelsesvælgerne */
  function placeSizeGuide() {
    var btn = document.querySelector('.product__info-container .hs-sg-btn');
    if (!btn || btn.__hsMoved) return;
    var inputs = document.querySelectorAll('.product__info-container variant-selects > .product-form__input');
    var target = null;
    inputs.forEach(function (inp) { var l = inp.querySelector('.form__label'); if (l && /størrelse|size/i.test(l.textContent)) target = inp; });
    if (!target) return;
    var lc = target.querySelector('.product-form__label-container') || target;
    lc.classList.add('hs-sg-row');
    lc.appendChild(btn);
    btn.__hsMoved = true;
  }
  function compactAll() { document.querySelectorAll('quantity-breaks').forEach(function (qb) { compactQb(qb); layoutRows(qb); }); updateSummaries(); }
  /* Temaet kan tegne bundlen igen ved variantskift, så den gøres kompakt igen bagefter */
  document.addEventListener('change', function () { setTimeout(compactAll, 300); setTimeout(compactAll, 1000); });

  /* 7. Bevisklip (snippets/hs-videoklip.liquid): stumt, i løkke mellem start og slut, kun når det ses. */
  function initClips() {
    document.querySelectorAll('[data-hs-klip]').forEach(function (box) {
      var v = box.querySelector('video');
      if (!v || v.__hs) return;
      v.__hs = true;
      var a = parseFloat(box.getAttribute('data-start')) || 0;
      var b = parseFloat(box.getAttribute('data-end')) || 0;
      var inView = false;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { v.controls = true; return; }
      var after = box.querySelector('.hs-klip__after');
      var holding = false;
      function replay() { try { v.currentTime = a; } catch (e) {} if (inView) v.play().catch(function () {}); }
      /* Slut på klippet: vis evt. stillbilledet (fx poten efter vask) i 2 sek., og start så forfra */
      function restart() {
        if (!after) { replay(); return; }
        if (holding) return;
        holding = true;
        v.pause();
        box.classList.add('is-after');
        setTimeout(function () { box.classList.remove('is-after'); holding = false; replay(); }, 2000);
      }
      v.addEventListener('timeupdate', function () { if (b && v.currentTime >= b - 0.1) restart(); });
      v.addEventListener('pause', function () { if (!holding && inView && b && v.currentTime >= b - 0.4) restart(); });
      v.addEventListener('loadedmetadata', function () {
        /* Slut efter videoens længde = hele videoen */
        if (v.duration && (!b || b > v.duration - 0.2)) b = v.duration - 0.2;
        if (v.currentTime < a) { try { v.currentTime = a; } catch (e) {} }
      });
      v.addEventListener('ended', function () { restart(); });
      if (!('IntersectionObserver' in window)) { inView = true; v.play().catch(function () {}); return; }
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          inView = en.isIntersecting;
          if (inView && !holding) v.play().catch(function () {}); else if (!inView) v.pause();
        });
      }, { threshold: 0.4 }).observe(v);
    });
  }

  /* 8. Fast købsbjælke på mobil: pris og "Læg i kurven". Vises, når hovedknappen er ude af syne,
        og skjules, mens cookie-banneret er åbent. Knappen sender hovedformularen (også 2 og 3 stk.).
        Kan varianten ikke købes, scroller den op til farve og størrelse. På computer styrer temaet selv. */
  function cookieOpen() {
    var c = document.getElementById('shopify-pc__banner');
    if (!c) return false;
    var r = c.getBoundingClientRect();
    return r.height > 0 && getComputedStyle(c).visibility !== 'hidden' && getComputedStyle(c).display !== 'none';
  }
  function initSticky() {
    var s = document.querySelector('sticky-atc');
    if (!s || s.__hs) return;
    s.__hs = true;
    var mq = window.matchMedia('(max-width: 749px)');
    var idInput = mainIdInput();
    var form = idInput && idInput.form;
    var btn = form && form.querySelector('[type="submit"]');
    var btnVisible = false;
    function upd() {
      if (!mq.matches) { s.classList.remove('hs-sticky-show', 'hs-sticky-hide'); document.body.classList.remove('hs-sticky-on'); return; }
      var show = !btnVisible && !cookieOpen();
      s.classList.toggle('hs-sticky-show', show);
      s.classList.toggle('hs-sticky-hide', !show);
      document.body.classList.toggle('hs-sticky-on', show);
    }
    if (btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { btnVisible = es[0].isIntersecting; upd(); }).observe(btn);
    }
    var sb = s.querySelector('button[type="submit"]');
    if (sb) sb.addEventListener('click', function (e) {
      if (btn && !btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      var vp = document.querySelector('variant-selects, variant-radios');
      if (vp) vp.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
    window.addEventListener('scroll', upd, { passive: true });
    document.addEventListener('click', function () { setTimeout(upd, 400); });
    if (mq.addEventListener) mq.addEventListener('change', upd);
    /* Cookie-banneret kan komme frem eller lukke når som helst: tjek hvert sekund */
    setInterval(upd, 1000);
    upd();
  }

  /* 9. Anmeldelser: højst 2 linjer. Er teksten længere, kommer der en "Læs mere"-knap. */
  function clampReviews() {
    document.querySelectorAll('.upform-reviews__card-text').forEach(function (p) {
      /* Skjulte anmeldelser (bag "Vis alle") tages, når de bliver vist */
      if (p.__hs || p.offsetParent === null) return;
      p.__hs = true;
      p.classList.add('hs-clamp');
      if (p.scrollHeight <= p.clientHeight + 2) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hs-more';
      b.textContent = 'Læs mere';
      b.addEventListener('click', function () { p.classList.remove('hs-clamp'); b.remove(); });
      p.parentNode.insertBefore(b, p.nextSibling);
    });
  }

  document.addEventListener('click', function () { setTimeout(clampReviews, 300); });

  /* 10. Leveringsplan (snippets/hs-leveringsplan.liquid): datoer i hverdage fra i dag */
  var MDR = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];
  function addWorkdays(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function fmt(d) { return d.getDate() + '. ' + MDR[d.getMonth()]; }
  function range(a, b) { return a.getMonth() === b.getMonth() ? a.getDate() + '.-' + fmt(b) : fmt(a) + '-' + fmt(b); }
  function initPlan() {
    document.querySelectorAll('[data-hs-plan]').forEach(function (el) {
      var now = new Date();
      var g = function (k) { return parseInt(el.getAttribute('data-' + k), 10) || 0; };
      var afs = range(addWorkdays(now, g('d1')), addWorkdays(now, g('d2')));
      var lev = range(addWorkdays(now, g('l1')), addWorkdays(now, g('l2')));
      var q = function (s) { return el.querySelector(s); };
      if (q('[data-hs-plan-afs]')) q('[data-hs-plan-afs]').textContent = afs;
      if (q('[data-hs-plan-lev]')) q('[data-hs-plan-lev]').textContent = lev;
      if (q('[data-hs-plan-lev2]')) q('[data-hs-plan-lev2]').textContent = lev;
    });
  }

  /* 11. Kopiér rabatkode (snippets/hs-velkomst.liquid) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hs-copy]');
    if (!b) return;
    var code = b.getAttribute('data-hs-copy');
    var label = b.querySelector('span');
    var done = function () { if (label) { label.textContent = 'Kopieret'; setTimeout(function () { label.textContent = code; }, 1600); } };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  /* 12. Tillidslinjen står lige under betalingsknapperne. Temaets UpForm-script samler knapperne
         i .upform-cta-row, efter linjen er tegnet, så den flyttes hen efter rækken. */
  function placeTrust() {
    var t = document.querySelector('.product__info-container .hs-tillid');
    var row = document.querySelector('.product__info-container > .upform-cta-row');
    if (t && row && row.nextElementSibling !== t) row.parentNode.insertBefore(t, row.nextSibling);
  }

  function init() {
    placeTrust();
    sizeLine();
    placeSizeGuide();
    setTimeout(placeSizeGuide, 800);
    setTimeout(placeTrust, 600);
    window.addEventListener('load', function () { setTimeout(placeTrust, 200); });
    initPlan();
    clampReviews();
    setTimeout(clampReviews, 1200);
    initClips();
    initSticky();
    compactAll();
    setTimeout(compactAll, 800);
    window.addEventListener('load', function () { setTimeout(compactAll, 300); });
    initReviewLink();
    qbPrices();
    setTimeout(qbPrices, 900);
    updateStock();
    enhanceAll();
    setTimeout(enhanceAll, 800);
    window.addEventListener('load', function () { setTimeout(enhanceAll, 300); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
